var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cancel-btn",class:_vm.$globalData.loading || _vm.$globalData.checked ? 'disabled' : '',on:{"click":_vm.emitClick}},[_c('span',[_vm._v("Cancel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }